import React, { useState, useEffect, useRef } from 'react';


const BANNER_IMAGES = [
  '/images/Banner01.jpg',
  '/images/Banner02.jpg',
  '/images/Banner03.jpg',
  '/images/Banner04.jpg',
  '/images/Banner05.png',
  '/images/Banner06.png',
  '/images/Banner07.png',
  '/images/Banner08.png',
  '/images/Banner09.png',
];

const HomePage = () => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % BANNER_IMAGES.length);
    }, 3000);
    return () => clearTimeout(timeoutRef.current);
  }, [current]);

  return (
    <div>
      <div className="banner" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', height: 520, overflow: 'hidden', marginBottom: 32, marginTop: 24 }}>
        {BANNER_IMAGES.map((img, idx) => (
          <img
            key={img}
            src={img}
            alt={`Banner ${idx + 1}`}
            className="banner-img"
            style={{
              maxWidth: '1200px',
              width: '100%',
              height: '520px',
              objectFit: 'cover',
              borderRadius: '12px',
              position: 'absolute',
              left: 0,
              top: 0,
              opacity: idx === current ? 1 : 0,
              transition: 'opacity 0.7s',
            }}
          />
        ))}
        <div style={{ position: 'absolute', bottom: 24, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 12 }}>
          {BANNER_IMAGES.map((_, idx) => (
            <span
              key={idx}
              style={{
                width: 16,
                height: 16,
                borderRadius: '50%',
                background: idx === current ? '#fff' : '#888',
                display: 'inline-block',
                cursor: 'pointer',
                border: '2px solid #222',
              }}
              onClick={() => setCurrent(idx)}
            />
          ))}
        </div>
      </div>
      <div className="description" style={{ padding: '2rem' }}>
        <h2>THE ULTIMATE LIVING EXPERIENCE</h2>
        <p>
          Located in the heart of Addis Ababa’s most dynamic district, The Enclave redefines urban luxury with 70 sophisticated one-, two-, and three-bedroom residences designed to exceed the highest standards of modern city living.
        </p>
        <h3>FLEXIBLE PAYMENT PLAN</h3>
        <p>
          The Enclave offers a convenient 8-installment payment plan spread over 24 months, allowing buyers to manage payments comfortably throughout the construction period. The project is scheduled for completion within two years, with handover to clients immediately upon completion. This structure ensures peace of mind, financial flexibility, and a smooth transition from purchase to occupancy.
        </p>
      </div>
    </div>
  );
};

export default HomePage;
